import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAlert } from "../../Services/appAlerts";
import WorkflowElement from "../../app/components/WorkflowElement";
import { addUpdateBprmFormHistory, formUpdateHistoryAdded,
   getFormUpdateHistoryStatus, getTaskFormSavedStatus, taskFormSaved } from "../../app/store/bprmForm";


const ViewForm = (props) => {
  const { workflowTask, selectedForm, handleFormShowHide,
    handleFormUpdate, allowEdit } = props;
    
  const [wfTask, setWfTask] = useState(null);
  const [saveBtnProcessStatus, setSaveBtnProcessStatus] = useState(true);
  const [updatedStateData, setUpdatedStateData] = useState(null);

  const formUpdateHistoryStatusSelector = useSelector(getFormUpdateHistoryStatus)
  const taskFormSavedStatusSelector = useSelector(getTaskFormSavedStatus);

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedForm?.id && workflowTask?.ciid)
      setWfTask({ formId: selectedForm.formId, ciid: workflowTask.ciid });
  }, [selectedForm]);

  const handleNextTask = (frmData) => {
    // Guard: only FormData coming from a form save is valid here.
    if (!(frmData instanceof FormData)) return;
    setSaveBtnProcessStatus(true);
    frmData.append("formLibrary", JSON.stringify(selectedForm));
    dispatch(addUpdateBprmFormHistory(frmData));
  }

  useEffect(() => {
    // Wait for BOTH the form save (SaveFormData) and the form-library history
    // update to complete, then show a single success alert. Previously the
    // save alert (WorkflowElement) and this alert both fired -> double popup.
    if (formUpdateHistoryStatusSelector && taskFormSavedStatusSelector) {
      getAlert("", "Saved Successfully", "success");
      setSaveBtnProcessStatus(false);
      dispatch(formUpdateHistoryAdded(false));
      dispatch(taskFormSaved(false));
      if (handleFormUpdate) handleFormUpdate();
      if (handleFormShowHide) handleFormShowHide("save");
    }
  }, [formUpdateHistoryStatusSelector, taskFormSavedStatusSelector]);

  return (
    <div>
      {wfTask?.formId > 0 && <WorkflowElement
        wfTask={wfTask}
        handleNextTask={handleNextTask}
        viewType={!allowEdit}
        appSummary={false}
        codeVerified={true}
        wfTaskType={"viewForm"}
        saveBtnProcessStatus={saveBtnProcessStatus}
        setSaveBtnProcessStatus={setSaveBtnProcessStatus}
        updatedStateData={updatedStateData}
      />}
    </div>
  );
}

export default ViewForm;
